module.exports = __webpack_public_path__ + "static/media/card-corteva.51268d0e.png";